import { useEffect, useRef, useState } from 'react';

type Props = {
  displayUrl: string;
};

const TABLEAU_SCRIPT_URL = 'https://public.tableau.com/javascripts/api/tableau.embedding.3.latest.min.js';

export const TableauEmbedding = ({ displayUrl }: Props) => {
  const vizRef = useRef<HTMLElement | null>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [isScriptLoaded, setIsScriptLoaded] = useState(false);

  // Load the Tableau script
  useEffect(() => {
    const existingScript = document.querySelector(`script[src="${TABLEAU_SCRIPT_URL}"]`);

    if (existingScript) {
      setIsScriptLoaded(true);
      return;
    }

    const script = document.createElement('script');
    script.src = TABLEAU_SCRIPT_URL;
    script.type = 'module';
    script.async = true;

    script.onload = () => {
      setIsScriptLoaded(true);
    };

    script.onerror = () => {
      console.error('Failed to load Tableau script');
    };

    document.head.appendChild(script);

    return () => {
      // Only remove if no other Tableau embeds are using it
      const otherTableauElements = document.querySelectorAll('tableau-viz');
      if (otherTableauElements.length === 0) {
        script.remove();
      }
    };
  }, []);

  useEffect(() => {
    const container = containerRef.current;
    if (!container || !isScriptLoaded) return;

    const viz = document.createElement('tableau-viz');
    viz.setAttribute('src', displayUrl);
    viz.setAttribute('width', '100%');
    viz.setAttribute('height', '600');

    viz.addEventListener('firstinteractive', () => {
      vizRef.current = viz;
      setIsLoaded(true);
    });

    container.appendChild(viz);

    return () => {
      container.innerHTML = '';
    };
  }, [displayUrl, isScriptLoaded]);

  return (
    <div>
      <div ref={containerRef} />
    </div>
  );
};